import * as React from "react";
import type { SVGProps } from "react";
const SvgSpinner = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2c.55 0 1 .45 1 1s-.45 1-1 1c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8c0-.55.45-1 1-1s1 .45 1 1c0 5.51-4.49 10-10 10"
    />
  </svg>
);
export default SvgSpinner;
